import React from "react";
import Chart from "react-apexcharts";
import { useNavigate } from "react-router-dom";

const ConditionTasksChart = ({ data, permits, appliedFilters = {}, assets = [] }) => {
  const navigate = useNavigate();

  const canShowData =
    permits.isSuperuser || (permits.hasAnyRole && permits.canTasksRead);

  const categories = ["Pendiente", "Iniciada", "Finalizada"];

  const mockData = {
    Asignada: { Pendiente: 4, Iniciada: 1, Finalizada: 0 },
    Delegada: { Pendiente: 40, Iniciada: 3, Finalizada: 2 },
  };

  const chartData = canShowData ? data : mockData;

  const series = [
    {
      name: "Asignada",
      data: categories.map((cat) => chartData.Asignada?.[cat] || 0),
    },
    {
      name: "Delegada",
      data: categories.map((cat) => chartData.Delegada?.[cat] || 0),
    },
  ];

  // Función para construir URL con AMBOS filtros del Dashboard
  const buildNavigationUrl = (condition, status) => {
    const params = new URLSearchParams();
    
    // Agregar parámetros del gráfico
    params.append('condition', condition);
    params.append('status', status);
    
    // ✅ Agregar filtros de ACTIVOS del Dashboard
    if (appliedFilters.asset && appliedFilters.asset.length > 0) {
      const assetNames = appliedFilters.asset
        .map(code => assets.find(a => a.code === code)?.name)
        .filter(Boolean);
      
      if (assetNames.length > 0) {
        params.append('assets', assetNames.join(','));
      }
    }
    
    // Agregar filtros de ÁREAS del Dashboard
    if (appliedFilters.area && appliedFilters.area.length > 0) {
      const allFilterAreas = assets.reduce((acc, asset) => {
        if (asset.filter_areas) {
          asset.filter_areas.forEach(area => {
            if (!acc.find(a => a.id === area.id)) {
              acc.push(area);
            }
          });
        }
        return acc;
      }, []);

      const areaNames = appliedFilters.area
        .map(id => allFilterAreas.find(a => a.id === id)?.name)
        .filter(Boolean);
      
      if (areaNames.length > 0) {
        params.append('areas', areaNames.join(','));
      }
    }
    
    return `/tasks?${params.toString()}`;
  };

  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      events: {
        dataPointSelection: (event, chartContext, config) => {
          const condition = series[config.seriesIndex].name;
          const status = categories[config.dataPointIndex];
          if (canShowData) {
            navigate(buildNavigationUrl(condition, status)); // Navega con ambos filtros
          }
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "60%",
        borderRadius: 4,
      },
    },
    xaxis: { categories },
    yaxis: {
      tickAmount: 6,
      forceNiceScale: true,
      labels: {
        formatter: (val) => val.toFixed(0),
      },
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
      fontSize: "12px",
      markers: { width: 10, height: 10 },
      itemMargin: { horizontal: 8, vertical: 0 },
    },
    dataLabels: { enabled: true },
    colors: canShowData
      ? ["#9B59B6", "#2ECC71"]
      : ["#CCCCCC", "#AAAAAA", "#AAAAAA", "#888888", "#777777"],
  };

  return (
    <div
      style={{
        position: "relative",
        cursor: canShowData ? "default" : "not-allowed",
      }}
    >
      <Chart options={options} series={series} type="bar" height={375} />
      {!canShowData && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(255,255,255,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 16,
            fontWeight: "bold",
            color: "#555",
          }}
        >
          No tienes permisos para ver este gráfico
        </div>
      )}
    </div>
  );
};

export default ConditionTasksChart;